import { bootstrapApp } from '@backoffice-frontend/authenticated-app-view'
import { App } from './lib/App'

bootstrapApp(
  App,
  'https://fb8de72a7a01c605a53639b30988c1eb@o4508878881685504.ingest.de.sentry.io/4508878913077328',
)
